<template>
  <div class="base-intro">
    <template v-if="isOtgDevice || isNFCDevice">
      <div class="page-rnr-person-base-step-wrapper small">
        <div class="page-rnr-person-base-step">请将身份证放置在设备读取区域中</div>
      </div>
      <div class="page-rnr-person-base-btn-wrap">
        <van-button plain round hairline type="primary" block color="#0761F3" @click="handleReadNFCData">读取信息</van-button>
      </div>
    </template>
    <template v-else-if="supportBluetooth">
      <div class="page-rnr-person-base-step-wrapper">
        <div class="page-rnr-person-base-step">STEP  1：请使用手机蓝牙连接身份读卡器</div>
        <div class="page-rnr-person-base-step">STEP  2：请将身份证放置身份证读卡器上</div>
      </div>
      <div class="page-rnr-person-base-btn-wrap">
        <template v-if="isConnect">
          <van-button plain round hairline type="primary" block color="#0761F3" @click="handleReadData">读取信息</van-button>
          <div class="page-rnr-person-base-btn-block" @click="handleConnectToDevice">
            <i class="page-rnr-person-base-icon-switch" />切换设备
          </div>
        </template>
        <van-button v-else color="#0761F3" round plain hairline block type="primary" @click="handleConnectToDevice">
          <i class="page-rnr-person-base-icon-bluetooth" />蓝牙连接
        </van-button>
      </div>
    </template>
  </div>
</template>

<script>
import { Toast } from 'vant'
import dayjs from 'dayjs'
import bridge from '@/utils/bridge'

export default {
  name: 'Bluetooth',
  data() {
    return {
      isConnect: false,
      isOtgDevice: false,
      isNFCDevice: false,
      supportBluetooth: false
    }
  },
  activated() {
    // 页面展示的时候加载一下设备链接状态
    if (this.supportBluetooth) this.getDeviceConnectStatus()
    // 当前是否是NFC设备
    bridge.geOtgReadType((code = '') => {
      this.isOtgDevice = ['X960_6762_66_P', 'ST010-A', 'ST010'].includes(code.toUpperCase())
      this.isNFCDevice = ['S61', 'PD3 PRO', 'PD3-B'].includes(code.toUpperCase())
    })
  },
  methods: {
    /**
     * 读取nfc设备数据
     */
    handleReadNFCData() {
      return new Promise((resolve, reject) => {
        (this.isOtgDevice ? bridge.readIDCardByOTG : bridge.readIdCardByNFC)(result => {
          console.log('设备信息：', this.isOtgDevice, result)
          this.setUserData(result)
          resolve(result)
        })
      })
    },

    /**
     * 从设备上读取身份证信息
     */
    handleReadData() {
      return new Promise((resolve, reject) => {
        bridge.getDeviceData((result) => {
          console.log('设备信息：', result)
          this.setUserData(result)
          resolve(result)
        })
      })
    },

    /**
     * 获取设备链接状态
     */
    getDeviceConnectStatus() {
      // 调用读卡器链接状态
      bridge.deviceConnectStatus((result) => {
        console.log('读卡器连接状态: ', result)
        // 当前链接状态
        this.isConnect = result === 'true'
      })
    },

    /**
     * 连接蓝牙
     */
    async handleConnectToDevice() {
      // 读取数据
      bridge.chooseBluetoothDevice(result => {
        console.log('读卡器连接状态: ', result)
        // 当前链接状态
        this.isConnect = result === 'true'
      })
    },

    /**
     * 设置用户信息
     * @param result 读取器读取的用户信息
     */
    setUserData(result) {
      // 过期时间
      const expireDate = dayjs(result.expireDate, 'YYYYMMDD')
      // 承载当前读取的值
      const formData = {}
      // 开始赋值
      formData.fullName = result.name
      formData.gender = result.gender === '男' ? 1 : 2
      formData.certNumber = result.idNum
      formData.certExpirationDate = expireDate.isValid() ? expireDate.format('YYYY-MM-DD') : result.expireDate
      // 如果当前选的日期小于当前天
      if (expireDate.isValid() && expireDate.isBefore(dayjs().startOf('date'))) {
        Toast('当前身份证已过期，请注意更换')
        formData.certExpirationDate = ''
      }
      formData.certAddress = result.address
      // 通知外层组件当前值
      this.$emit('change', { ...formData })
    }
  }
}
</script>

<style lang="scss" scoped>
.base-intro{
  .page-rnr-person-base-icon-idcard-reader {
    background-image: url(../assets/rnr/ico_idcard_reader.png);
    background-size: auto 100%;
    background-position: center center;
    width: 100%;
    height: 272px;
    margin: 0 auto;
  }
  .page-rnr-person-base-step-wrapper {
    margin-top: 12px;
    height: 128px;
    .page-rnr-person-base-step {
      color: rgba(36, 36, 36, 0.4);
      font-size: 24px;
      font-weight: 400;
      line-height: 30px;
      margin-top: 8px;
      height: 60px;
      &:first-child {
        margin-top: 0;
      }
    }
    &.small {
      height: 60px;
    }
  }
  .page-rnr-person-base-btn-wrap {
    margin-top: 24px;
    .van-button {
      font-size: 30px;
      height: 88px;
      .page-rnr-person-base-icon-bluetooth {
        background-image: url(../assets/rnr/ico_bluetooth.png);
        background-size: 100% 100%;
        display: inline-block;
        width: 30px;
        height: 30px;
        margin-right: 12px;
        margin-bottom: -4px;
      }
    }
    .page-rnr-person-base-btn-block {
      align-items: center;
      border-radius: 50%;
      color: #0761F3;
      display: flex;
      font-size: 30px;
      height: 88px;
      justify-content: center;
      margin-top: 24px;
      .page-rnr-person-base-icon-switch {
        background-image: url(../assets/rnr/ico_switch.png);
        background-size: 100% 100%;
        display: inline-block;
        width: 30px;
        height: 30px;
        margin-right: 12px;
        margin-bottom: -4px;
      }
    }
  }
  &.base-intro {
    padding: 0px 32px !important;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bluetooth.vue